import React from "react";
import styles from "./AccreditationHome.module.css";
import Image from "next/image";
import Link from "next/link";
import { ArrowRight } from "lucide-react";

interface AccreditationImage {
  id: number;
  documentId: string;
  url: string;
  alternativeText: string | null;
}

interface TitleLink {
  id: number;
  title: string;
  link: {
    id: number;
    label: string;
    url: string;
  };
  description: string;
}

interface AccreditationsProps {
  id: number;
  title_link: TitleLink;
  images: AccreditationImage[];
  title_description: TitleLink;
}

interface Props {
  data: AccreditationsProps;
  className?: string;
}

const AccreditationHome: React.FC<Props> = ({ data, className }) => {
  return (
    <div
      className={`${styles.accreditation_row} ${
        className ? styles.aboutAccreditations : ""
      }`}
      data-section="AccreditationHome"
      style={{ minHeight: "250px", overflow: "hidden" }}
    >
      <div className="container">
        <div className={styles.accHeading} style={{ minHeight: "80px" }}>
          <div className="d-flex justify-content-between align-items-center">
            <h2 className="text-left">
              {data?.title_link?.title
                ? data?.title_link?.title
                : data?.title_description?.title}
            </h2>
            {data?.title_link?.link && (
              <div className="d-none d-md-block">
                <Link
                  href={data?.title_link?.link?.url}
                  className="text-right"
                  aria-label="Learn more about accreditation"
                  title="Learn more about accreditation"
                  shallow
                >
                  {data?.title_link?.link?.label}
                  <span className="visually-hidden">Button</span>{" "}
                  <ArrowRight style={{ width: "16px", height: "16px" }} />
                </Link>
              </div>
            )}
          </div>
          {data?.title_description?.description && (
            <p>{data?.title_description?.description}</p>
          )}
        </div>
        <div className={styles.allAccLogo}>
          <div className="row align-items-center justify-content-center">
            {data.images.map((image, index) => (
              <div
                key={image.id}
                className={`col-4 col-md-2 text-center ${
                  index < data.images.length - 1 ? "border-end" : ""
                }`}
                style={{ minHeight: "60px" }}
              >
                <div
                  className={styles.imageWrapper}
                  style={{
                    width: "93px",
                    height: "48px",
                    aspectRatio: "93/48",
                  }}
                >
                  <Image
                    src={image?.url}
                    alt={image?.alternativeText || "Accreditation Logo"}
                    title={image?.alternativeText || "Accreditation Logo"}
                    width={93}
                    height={48}
                    className={styles.AccreditationImg}
                    priority={index === 0}
                    loading={index === 0 ? "eager" : "lazy"}
                    sizes="(max-width: 768px) 50vw, 93px"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
        {data?.title_link?.link && (
          <div
            className={`d-block d-md-none ${styles.moreBTn}`}
            style={{ minHeight: "40px" }}
          >
            <Link
              href={data?.title_link?.link?.url}
              className="d-block text-center"
              shallow
              title={data?.title_link?.link?.label}
            >
              {data?.title_link?.link?.label}
              <span className="visually-hidden">Button</span>
              <ArrowRight
                aria-hidden="true"
                style={{ width: "16px", height: "16px" }}
              />
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default AccreditationHome;
